import { Nullable } from '@form-engine/core-util/typings';
import React from 'react';
import BuilderAppError from './error';

export interface ErrorBoundaryProps {
    children?: React.ReactNode;
    errorComponent?: React.ElementType;
}

interface ErrorBoundaryState {
    error: Nullable<Error>;
}

export default class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { error: null };
    }

    componentDidCatch(error: Error) {
        this.setState({ error });
    }

    render() {
        const { error } = this.state;
        const { children, errorComponent: Error = BuilderAppError } =
            this.props;
        if (error) {
            return <Error error={error} />;
        } else {
            return children;
        }
    }
}
